import React from "react";
import {BabyButton, ProfileModal, useWindowSize} from "@housebets/housebets-x-package";
import {useProfileDropdownData} from "./hooks/useProfileDropdown";
import {RedeemModal, UserInfoModal} from "../../modals";
import {useRewardProgressData} from "../../rewards/RewardProgress/hooks/useRewardProgressData";
import {copyToBuffer} from "app/utils/copy-to-buffer";
import {LogoutModal} from "../../modals/LogoutModal";
import {useIntl} from "react-intl";

export const ProfileDropdown: React.FC = () => {
    const {
        isOpen,
        setIsOpen,
        mutatedUserData,
        messageTotalCount,
        loggedTextData,
        links,
        isOpenRedeemModal,
        setIsOpenRedeemModal,
        onFileAdd,
        onFileTypeError,
        isUserInfoModalOpen,
        setIsUserInfoModalOpen,
        isLogoutModalOpen,
        setIsLogoutModalOpen,
    } = useProfileDropdownData();
    const {isMobile, isTablet} = useWindowSize();
    const {$t} = useIntl();

    const {revard, nextRevard} = useRewardProgressData();

    return (
        <>
            <ProfileModal
                textCopy={{
                    copy: $t({id: "CopyUserId"}),
                    nextLevel: $t({id: "NextLevel"}), // Assuming this is the correct translation key
                }}
                onClickCopyUserId={() => copyToBuffer(mutatedUserData.id)}
                reward={revard}
                nextRevard={nextRevard}
                vipWidgetData={loggedTextData}
                setIsOpen={setIsOpen}
                isOpen={isOpen}
                blockPageScroll
                // TODO: Remove this after the image upload feature is implemented
                userConfigurable={false}
                onFileAdd={onFileAdd}
                onFileTypeError={onFileTypeError}
                user={{
                    ...mutatedUserData,
                    level: mutatedUserData?.level || "",
                }}
                links={links.map((item) => {
                    if (item.id === "RedeemCode") {
                        return {
                            ...item,
                            onClick: () => {
                                setIsOpenRedeemModal(true);
                            },
                        };
                    }

                    return item;
                })}
                statsLink=""
                trigger={
                    <BabyButton.User
                        title={$t({id: "User"})}
                        kind={isMobile || isTablet ? "transparent" : "green"}
                        size={isMobile || isTablet ? "sm" : "md"}
                        count={messageTotalCount}
                        onClick={() => {
                            setIsOpen((prev) => !prev);
                        }}
                    />
                }
            />
            <RedeemModal isOpen={isOpenRedeemModal} setIsOpen={setIsOpenRedeemModal} />
            <UserInfoModal isOpen={isUserInfoModalOpen} setIsOpen={setIsUserInfoModalOpen} />
            <LogoutModal isOpen={isLogoutModalOpen} setIsOpen={setIsLogoutModalOpen} />
        </>
    );
};

ProfileDropdown.displayName = "ProfileDropdown";
